<template>
    <article class="article --food-ontbijt">
        <section class="article__intro">
            <div class="container">
                <h1 v-html="$t('articles.foodOntbijt.title')"></h1>
            </div>
            <div class="article__intro__scrolldown" v-scroll-to="'.article__body'"></div>
        </section>   

        <section class="article__body pt-xs-40 pb-xs-40 pb-md-60">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 offset-lg-2">
                        <p class="article__intro__txt t-center t-color-third mb-xs-40 mb-md-60">{{ $t('articles.foodOntbijt.intro') }}</p>
                        <p class="t-center mb-xs-40 mb-md-60">{{ $t('articles.foodOntbijt.block1.description') }}</p>
                        <h3 class="t-center">{{ $t('articles.foodOntbijt.block2.title') }}</h3>
                        <p class="t-center">{{ $t('articles.foodOntbijt.block2.description') }}</p>
                    </div>
                </div>
            </div>
        </section>
        
        <section class="mb-xs-20 mb-md-60">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 offset-lg-2">
                        <div class="row">
                            <div class="col-md-7">
                                <h3>{{ $t('articles.foodOntbijt.block3.title') }}</h3>
                                <p v-html="$t('articles.foodOntbijt.block3.description')"></p>
                            </div>
                            <div class="col-md-5">
                                <img class="mt-xs-30 mb-xs-30 mt-md-20 mb-md-20 mlr-auto" style="max-width:350px;" src="../../assets/img/articles/ontbijt.png">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="article__tip pt-xs-40 pt-md-80 pb-xs-20 pb-md-140 mb-xs-40 mb-md-0">
            <div class="container">
                <div class="row">
                    <div class="col-5">
                        <img src="../../assets/img/articles/article-sport-kiwi-tip.png" alt="">
                    </div>
                    <div class="col-7">
                        <h2 class="t-color-food mb-xs-15">{{ $t('common.tip') }}</h2>
                        <p class="article__tip__txt">{{ $t('articles.foodOntbijt.tip') }}</p>
                    </div>
                </div>
            </div>
        </section>

        <section class="mb-xs-60 mb-lg-100">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 offset-lg-2">
                        <div class="row mb-xs-20 mb-md-40">
                            <div class="col-12">
                                <h3>{{ $t('articles.foodOntbijt.block4.title') }}</h3>
                                <p>{{ $t('articles.foodOntbijt.block4.description') }}</p>
                            </div>
                        </div>

                        <div class="row mb-xs-20 mb-md-40">
                            <div class="col-12">
                                <h3>{{ $t('articles.foodOntbijt.block5.title') }}</h3>
                                <p v-html="$t('articles.foodOntbijt.block5.description')"></p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <p class="disclaimer">{{ $t('articles.foodOntbijt.disclaimer1') }}</p>
                                <p class="disclaimer">{{ $t('articles.foodOntbijt.disclaimer2') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="article__related pt-xs-60 pb-xs-120">
            <div class="container">
                <h3 class="text-center mb-xs-40">{{ $t('articles.common.related') }}</h3>
            </div>
            <div v-swiper:relatedSwiper="relatedSwiperOptions">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="article-link">
                            <router-link :to="{name: $t('routes.food.fruit')}">
                                <img src="../../assets/img/articles/thumb-6.jpg">
                                <div class="p-xs-5 p-sm-10 p-md-15">
                                    <div class="article-link__title">{{ $t('articles.foodFruit.cleanTitle') }}</div>
                                    <div>> {{ $t('common.ontdek') }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="article-link">
                            <router-link :to="{name: $t('routes.sport.kiwi')}">
                                <img src="../../assets/img/articles/thumb-1.jpg">
                                <div class="p-xs-5 p-sm-10 p-md-15">
                                    <div class="article-link__title">{{ $t('articles.sportApps.cleanTitle') }}</div>
                                    <div>> {{ $t('common.ontdek') }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="article-link">
                            <router-link :to="{name: $t('routes.sport.apps')}">
                                <img src="../../assets/img/articles/thumb-2.jpg">
                                <div class="p-xs-5 p-sm-10 p-md-15">
                                    <div class="article-link__title">{{ $t('articles.sportApps.cleanTitle') }}</div>
                                    <div>> {{ $t('common.ontdek') }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="article-link">
                            <router-link :to="{name: $t('routes.mind.humeur')}">
                                <img src="../../assets/img/articles/thumb-3.jpg">
                                <div class="p-xs-5 p-sm-10 p-md-15">
                                    <div class="article-link__title">{{ $t('articles.mindHumeur.cleanTitle') }}</div>
                                    <div>> {{ $t('common.ontdek') }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="article-link">
                            <router-link :to="{name: $t('routes.mind.lachen')}">
                                <img src="../../assets/img/articles/thumb-4.jpg">
                                <div class="p-xs-5 p-sm-10 p-md-15">
                                    <div class="article-link__title">{{ $t('articles.mindLachen.cleanTitle') }}</div>
                                    <div>> {{ $t('common.ontdek') }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="swiper-navigation">
                <div class="swiper-navigation-button swiper-navigation-button--prev" v-on:click="relatedSwiper.slidePrev()"></div>
                <div class="swiper-navigation-button swiper-navigation-button--next" v-on:click="relatedSwiper.slideNext()"></div>
            </div>
        </section>

        <section class="article__blog pt-xs-40 pt-md-100 pb-xs-20 pb-md-100">
            <div class="container">
                <h3 class="text-center mb-xs-40">{{ $t('articles.common.moreBlog') }}</h3>
                <div class="row">
                    <div class="col-lg-8 offset-lg-2">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="article-link mb-xs-20 mb-sm-0">
                                    <a :href="$t('blog.article5.url')" target="_blank">
                                        <img src="../../assets/img/articles/thumb-blog-5.jpg">
                                        <div class="p-xs-5 p-md-15">
                                            <div class="article-link__title --blog">{{ $t('blog.article5.title') }}</div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="article-link">
                                    <a :href="$t('blog.article6.url')" target="_blank">
                                        <img src="../../assets/img/articles/thumb-blog-6.jpg">
                                        <div class="p-xs-5 p-md-15">
                                            <div class="article-link__title --blog">{{ $t('blog.article6.title') }}</div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </article>
</template>

<script>

export default {
  name: "FoodOntbijt",
  data() {
    return {
        relatedSwiperOptions: {
            loop: false,
            direction: 'horizontal',
            spaceBetween: 30,
            breakpoints: {
                320: {
                slidesPerView: 1.2
                },
                640: {
                slidesPerView: 2.4
                },
                992: {
                slidesPerView: 4.6
                }
            }
        }
    }
  },
  mounted() {
  },
};
</script>